import BulkManageMobileDrawer from "common/components/BulkManageMobileDrawer";

import { MANAGE_AUDIENCE_ACTIONS } from "../../../constants";
import ExportTargets from "./ExportTargets";
import RemoveTargets from "./RemoveTargets";

import type { AudienceFilters, AudienceProfile } from "../../../types";

interface ManageMobileAudienceProps {
  selectedTargets: AudienceProfile[];
  resetSelectedTargets: () => void;
  filters?: AudienceFilters;
}

export default function ManageMobileAudience({
  selectedTargets,
  resetSelectedTargets,
  filters,
}: ManageMobileAudienceProps) {
  return (
    <BulkManageMobileDrawer
      drawerLabel="audience"
      actions={MANAGE_AUDIENCE_ACTIONS}
      selection={selectedTargets}
      renderActionComponent={({ action, onClose, onBack }) => {
        const props = {
          selectedTargets,
          onBack,
          onSuccess: () => {
            onClose();
            resetSelectedTargets();
          },
          filters,
        };

        if (action === "export") {
          return <ExportTargets {...props} />;
        }
        if (action === "remove") {
          return <RemoveTargets {...props} />;
        }
      }}
    />
  );
}
